import type { StateCreator } from 'zustand';
interface UpsellCalculation {
  total_pedido: string | null;
  total_adesao: string | null;
  total_mensalidade: string | null;
}
interface FiltersSliceState {
  delayUpsell: boolean;
  dealUpsellId: string;
  companyUpsellId: string;
  upsellCalculation: UpsellCalculation;
  isLoadingNextStep: boolean;
  isFinishUpsell: boolean;
  setIsFinishUpsell: (isFinishUpsell: boolean) => void;
  setUpsellCalculation: (upsellCalculation: UpsellCalculation) => void;
  setDelayUpsell: (delay: boolean) => void;
  setDealUpsellId: (dealId: string) => void;
  setCompanyUpsellId: (companyId: string) => void;
  setIsLoadingNextStep: (isLoading: boolean) => void;
  reset: () => void;
}

type StateCreatorFilters = StateCreator<FiltersSliceState, [['zustand/devtools', never]], [], FiltersSliceState>;

const defaultDetailData = {
  delayUpsell: true,
  dealUpsellId: '',
  companyUpsellId: '',
  upsellCalculation: {
    total_pedido: null,
    total_adesao: null,
    total_mensalidade: null,
  },
  isLoadingNextStep: false,
  isFinishUpsell: false,
};

const createFiltersSlice: StateCreatorFilters = (set) => ({
  delayUpsell: defaultDetailData.delayUpsell,
  dealUpsellId: defaultDetailData.dealUpsellId,
  companyUpsellId: defaultDetailData.companyUpsellId,
  isLoadingNextStep: defaultDetailData.isLoadingNextStep,
  upsellCalculation: defaultDetailData.upsellCalculation,
  isFinishUpsell: defaultDetailData.isFinishUpsell,
  setIsFinishUpsell: (isFinishUpsell: boolean) => set({ isFinishUpsell }),
  setUpsellCalculation: (upsellCalculation: UpsellCalculation) => set({ upsellCalculation }),
  setDelayUpsell: (delayUpsell: boolean) => set({ delayUpsell }),
  setDealUpsellId: (dealUpsellId: string) => set({ dealUpsellId }),
  setCompanyUpsellId: (companyUpsellId: string) => set({ companyUpsellId }),
  setIsLoadingNextStep: (isLoadingNextStep: boolean) => set({ isLoadingNextStep }),
  reset: () => {
    set(defaultDetailData);
  },
});

export type { FiltersSliceState };
export default createFiltersSlice;
